import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AltaCuestionariosComponent } from './alta-cuestionarios/alta-cuestionarios.component';
import { authGuardSubmodule } from '../../auth/auth.guard';
import { ContenedorComponent } from '../contenedor/contenedor.component';
import { EstructuracionComponent } from './estructuracion/estructuracion.component';
import { PonderacionComponent } from './ponderacion/ponderacion.component';
import { ResponsablesPlanesComponent } from './responsables-planes/responsables-planes.component';

const routes: Routes = [
  {
      path: 'app/administrador-cuestionarios',
      component: ContenedorComponent,
      children: [
        {path: 'alta', component: AltaCuestionariosComponent, canActivate: [authGuardSubmodule]},
        {path: 'estructuracion', component: EstructuracionComponent, canActivate: [authGuardSubmodule]},
        {path: 'ponderacion', component: PonderacionComponent, canActivate: [authGuardSubmodule]},
        {path: 'responsables-planes', component: ResponsablesPlanesComponent, canActivate: [authGuardSubmodule]}

      ],
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdministradorRoutingModule { }
